import styled from "styled-components"

export const Navigation = styled.div.attrs({
  className: `flex w-full justify-end`,
})``